// Centralised site config / content for Car Spa landing page
export const SITE = {
  brand: "CARSPA CLUB",
  tagline: "Ruční detailing v Praze — Čestlice & Butovice",
  whatsappNumber: "+420 732 434 878",
  whatsappRaw: "420732434878",
  email: "info@automyckacestlice.cz",
  price: "2 999 Kč",
  priceNumeric: 2999,
  suvSurchargePct: 20,
  vehicleSizes: [
    { key: "standard", label: "Osobní vůz", hint: "standardní cena" },
    { key: "suv", label: "SUV / velký vůz", hint: "+20 %" },
  ],
  clients: [
    "Toyota Tsusho",
    "Havex Auto",
    "Invelt",
    "Tesla",
    "Lexus Průhonice",
    "Restaurace Grosseto",
  ],
  addons: [
    { key: "koch", label: "Top keramika Koch (1 vrstva)", desc: "Profesionální keramický povlak — roky ochrany a hloubkový lesk.", price: 6000, premium: true },
    { key: "gyeon", label: "Keramická ochrana kůže Gyeon", desc: "Kůže odolná proti otěru, džínům a UV. Jako nová po letech.", price: 4500, premium: true },
    { key: "ceramic", label: "Keramický sealant laku", desc: "12 měsíců lesku a odpuzování vody. Nejoblíbenější.", price: 1490, popular: true },
    { key: "upholstery", label: "Tepování sedaček", desc: "Mokrá cesta — pryč s fleky a zápachem.", price: 990 },
    { key: "headlights", label: "Renovace světlometů", desc: "Zamlžené plasty zpět do křišťálového stavu.", price: 890 },
    { key: "leather", label: "Impregnace kůže", desc: "Výživa a ochrana proti praskání.", price: 690 },
    { key: "engine", label: "Čištění motoru", desc: "Motorový prostor jako z autosalonu.", price: 590 },
    { key: "ozone", label: "Ozonová dezinfekce", desc: "Zabije bakterie, zápach kouře i po zvířatech.", price: 490 },
    { key: "glass", label: "Nano ochrana skel", desc: "Tekuté stěrače — déšť sjíždí sám.", price: 390 },
  ],
  bundles: [
    {
      key: "ceramic_pack",
      label: "Keramický balíček",
      tag: "Top volba",
      desc: "Koch keramika na lak + Gyeon keramika na kůži. Maximální ochrana na roky, zvenku i zevnitř.",
      addons: ["koch", "gyeon"],
      price: 8900,
    },
    {
      key: "protection",
      label: "Kompletní ochrana",
      tag: "3 v 1",
      desc: "Sealant + nano skla + ozon. Auto chráněné zvenku i zevnitř na celý rok.",
      addons: ["ceramic", "glass", "ozone"],
      price: 1990,
    },
  ],
  locations: [
    {
      key: "cestlice",
      phone: "730 595 595",
      name: "Praha Čestlice",
      address: "Aquapalace Praha, Pražská 138, 251 01 Čestlice",
      hint: "Areál Aquapalace Praha",
      hours: "Po–Pá 8:00–18:00 · So–Ne zavřeno",
    },
    {
      key: "butovice",
      phone: "732 327 777",
      name: "Praha Butovice",
      address: "Corall Office Park, budova D, Bucharova 1314/8, 158 00 Praha 5 — Butovice",
      hint: "Parkovací garáže budovy D",
      hours: "Po–Pá 8:00–18:00 · So–Ne zavřeno",
    },
  ],
  hero: {
    eyebrow: "Ruční detailing · Praha · Čestlice & Butovice",
    headlineLines: ["Nastupte zítra do auta,", "ze kterého se vám", "nebude chtít vystoupit."],
    sub: "Ruční mytí, dekontaminace, jednokrokové leštění laku a interiér suchou cestou. Vše za 2 999 Kč. Hotovo do jednoho dne.",
    cta: "Objednat za 2 999 Kč",
    ctaSub: "Ozveme se vám a potvrdíme termín",
    bullets: [
      { label: "Kompletní mytí exteriéru + disky + sušení", price: "1 500 Kč" },
      { label: "Dekontaminace laku (chemická + clay)", price: "1 200 Kč" },
      { label: "Jednokrokové strojové rozleštění", price: "1 800 Kč" },
      { label: "Mytí interiéru suchou cestou", price: "800 Kč" },
    ],
    trust: [
      "4.9 ★ z 500+ recenzí na Google",
      "Spokojenost — nebo peníze zpět",
      "Žádné skryté poplatky",
    ],
  },
  stats: [
    { value: "1 500+", label: "spokojených aut ročně" },
    { value: "4.9 ★", label: "Google hodnocení" },
    { value: "7 let", label: "zkušeností v Praze" },
    { value: "2 999 Kč", label: "vše v jedné ceně" },
  ],
  valueStack: {
    title: "Jednotlivě by vás to stálo 5 300 Kč.",
    sub: "U nás dostanete úplně to samé v jednom balíčku — a ušetříte 2 301 Kč.",
    items: [
      { label: "Kompletní mytí exteriéru + disky + sušení", price: "1 500 Kč" },
      { label: "Dekontaminace laku (chemická + clay)", price: "1 200 Kč" },
      { label: "Jednokrokové strojové rozleštění laku", price: "1 800 Kč" },
      { label: "Mytí interiéru suchou cestou", price: "800 Kč" },
    ],
    total: "5 300 Kč",
    bundle: "2 999 Kč",
    save: "Ušetříte 2 301 Kč",
  },
  guarantee: {
    title: "Spokojenost nebo peníze zpět.",
    sub: "Pokud nebudete s výsledkem 100% spokojení, vrátíme vám peníze. Bez diskuze, bez drobného tisku.",
    points: [
      { title: "Pevná cena", text: "Žádné skryté příplatky. Co vidíte, to zaplatíte." },
      { title: "100% spokojenost", text: "Když nebudete nadšení, vracíme peníze." },
      { title: "Ozveme se vám", text: "Termín domluvíme telefonicky, shrnutí pošleme e-mailem." },
      { title: "Šetrné techniky", text: "Žádné kartáče, žádné poškrábaný lak. Garantujeme." },
    ],
  },
  faq: [
    {
      q: "Jak dlouho celý program trvá?",
      a: "Standardní program 2 999 Kč zabere přibližně 6–8 hodin. Auto u nás necháváte zpravidla celý pracovní den — ráno přivezete, večer vyzvedáváte v perfektní kondici.",
    },
    {
      q: "Co když nebudu s výsledkem spokojený?",
      a: "Po předání auto společně zkontrolujeme. Pokud něco nebude podle vašich představ, opravíme to na místě. Pokud byste stále nebyli spokojení, vracíme peníze.",
    },
    {
      q: "Vztahuje se cena 2 999 Kč i na SUV nebo dodávky?",
      a: "Standardní cena platí pro běžné osobní vozy. U SUV, MPV a větších vozů účtujeme příplatek 20 % — v rezervačním formuláři stačí zvolit „SUV / velký vůz“ a přesnou cenu vidíte okamžitě. Žádná překvapení.",
    },
    {
      q: "Můžu rezervaci přesunout nebo zrušit?",
      a: "Samozřejmě. Stačí napsat na WhatsApp +420 732 434 878 nejpozději den předem a najdeme nový termín.",
    },
    {
      q: "Jak často je vhodné program absolvovat?",
      a: "Pro dlouhodobou ochranu laku doporučujeme jednou za 6–12 měsíců. Mezi tím stačí běžné ruční mytí.",
    },
    {
      q: "Funguje program i pro elektromobily a hybridy?",
      a: "Ano, bez omezení. Suchá metoda čištění interiéru je naopak pro EV ideální — žádná vlhkost v citlivé elektronice.",
    },
  ],
  process: [
    {
      n: "01",
      title: "Předmytí pěnou a ruční mytí",
      duration: "≈ 60 min",
      tool: "Mycí rukavice z mikrovlákna + dvě vědra",
      img: "https://images.unsplash.com/photo-1781890381002-8cdb499b406a?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
      alt: "Ruční mytí tmavého vozu mycí rukavicí z mikrovlákna v pěně",
      text: "Aktivní pěna uvolní hrubé nečistoty ještě před dotykem. Poté myjeme ručně dvěma vědry s ochrannou mřížkou — písek zůstává na dně, ne na vašem laku.",
      bullets: ["Bezdotykové předmytí pěnou", "Mycí rukavice z mikrovlákna, nikdy houba ani kartáč", "Disky a pneumatiky zvlášť", "Sušení stlačeným vzduchem v lištách"],
    },
    {
      n: "02",
      title: "Dekontaminace laku",
      duration: "≈ 45 min",
      tool: "Chemická dekontaminace + clay disk",
      img: "https://images.unsplash.com/photo-1587742379711-0083b22a7ba1?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
      alt: "Detailer v nitrilových rukavicích ošetřuje lak mikrovláknem",
      text: "Polétavá rez, asfalt a živice se do laku zakousnou a běžné mytí je nesundá. Chemie je rozpustí, clay disk stáhne zbytek. Lak je hladký jako sklo — a připravený na leštění.",
      bullets: ["Odstranění železitých částic", "Asfalt, živice, hmyz", "Mechanická dekontaminace clay", "Bez rizika poškrábání"],
    },
    {
      n: "03",
      title: "Jednokrokové strojové leštění",
      duration: "≈ 3 hod",
      tool: "DA excentrická leštička + LED kontrola",
      img: "https://images.unsplash.com/photo-1708805282706-f44730b7e527?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
      alt: "Detailer leští kapotu vozu strojovou leštičkou",
      text: "Excentrická leštička s jednokrokovou pastou odstraní jemné škrábance, hologramy a zmatnění. Každý panel kontrolujeme pod LED světlem, dokud není lak hluboký a zrcadlový.",
      bullets: ["Odstranění jemných škrábanců", "Oživení barvy a hloubky laku", "Bezpečné pro všechny typy laku", "Kontrola panel po panelu"],
    },
    {
      n: "04",
      title: "Interiér suchou cestou",
      duration: "≈ 90 min",
      tool: "Detailingové štětce + suché čištění",
      img: "https://images.unsplash.com/photo-1771491237218-cbd4a707497e?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
      alt: "Detailer čistí palubní desku štětcem",
      text: "Důkladné vysátí včetně kufru, poté suché čištění čalounění, plastů, kůže a obrazovek. Žádná vlhkost, žádné fleky, žádný lepivý lesk — jen čistý, matný interiér jako z továrny.",
      bullets: ["Vysátí včetně kufru a spár", "Suché čištění čalounění a stropu", "Plasty, kůže, obrazovky", "Ideální i pro elektromobily"],
    },
  ],
  images: {
    heroBg: "https://images.pexels.com/photos/3954448/pexels-photo-3954448.jpeg?w=1920&q=80",
    heroBgAlt: "https://images.pexels.com/photos/707046/pexels-photo-707046.jpeg?w=1920&q=80",
    exterior: "https://images.pexels.com/photos/707046/pexels-photo-707046.jpeg?w=1200&q=80",
    decontamination: "https://images.pexels.com/photos/170811/pexels-photo-170811.jpeg?w=1200&q=80",
    polishing: "https://images.pexels.com/photos/3729464/pexels-photo-3729464.jpeg?w=1200&q=80",
    interior: "https://images.pexels.com/photos/1149831/pexels-photo-1149831.jpeg?w=1200&q=80",
  },
  services: [
    {
      n: "01",
      title: "Kompletní mytí exteriéru",
      icon: "Droplets",
      summary: "Ruční mytí dvouvědrovou metodou. Zvlášť čištěné disky, šetrné sušení vzduchem.",
      bullets: [
        "Předmytí pěnou pro odstranění hrubých nečistot",
        "Ruční mytí dvěma vědry s ochranou laku před škrábáním",
        "Hloubkové čištění disků a pneumatik",
        "Šetrné sušení mikrovláknem a stlačeným vzduchem v lištách a logách",
      ],
    },
    {
      n: "02",
      title: "Dekontaminace laku",
      icon: "Sparkles",
      summary: "Odstraníme polétavou rez, asfalt a živici, které běžné mytí nezvládne.",
      bullets: [
        "Chemická dekontaminace železitých částic",
        "Odstranění asfaltu, živice a hmyzu",
        "Mechanická dekontaminace clay barem / clay diskem",
        "Lak připraven na bezpečné rozleštění",
      ],
    },
    {
      n: "03",
      title: "Jednokrokové rozleštění laku",
      icon: "Sun",
      summary: "Oživíme barvu a odstraníme jemné škrábance pro hluboký, zrcadlový lesk.",
      bullets: [
        "Strojové leštění jednokrokovou pastou",
        "Odstranění jemných škrábanců a hologramů",
        "Oživení barvy a obnovení hloubky laku",
        "Finální setření a kontrola pod LED světlem",
      ],
    },
    {
      n: "04",
      title: "Mytí interiéru suchou cestou",
      icon: "Car",
      summary: "Důkladné vysátí a šetrné čištění suchou cestou — bez vlhka a fleků.",
      bullets: [
        "Důkladné vysátí celého interiéru včetně kufru",
        "Suché čištění čalounění a stropu",
        "Detailní čištění plastů, kůže a obrazovek",
        "Ošetření povrchů s matným, nelepivým finishem",
      ],
    },
  ],
  reviews: [
    {
      name: "Jakub H.",
      source: "Google",
      text: "K těmto službám jsem dosti kritický, protože sám si auta myji často a důkladně. Reklama na FB mě oslovila, a tak jsem vyzkoušel. 5* pro mě není standard, ale vysoká spokojenost. Auto vyčištěno a rozleštěno naprosto nad očekávání! Tady mohu tedy jedině doporučit.",
    },
    {
      name: "Petr M.",
      source: "Google",
      text: "Auto bylo po návštěvě Car SPA krásně umyté – nenašel jsem jediný problém. Jednokrokové leštění perfektně odstranilo staré zaschlé zbytky much. Výsledek splnil očekávání.",
    },
    {
      name: "Martin V.",
      source: "Google",
      text: "Car SPA navštěvuji pravidelně. Od první návštěvy uplynulo pár měsíců a už tam jedu se třetím vozem. Získali si mě profesionálním přístupem a jednáním, příjemným personálem a v neposlední řadě skvěle odvedenou prací. Výsledkem je provoněné vozidlo, textilní sedačky vytepovány bez následného objevení fleků zpět.",
    },
    {
      name: "Tomáš K.",
      source: "Google",
      text: "Precizní vyčištění a umytí vozu za perfektní ceny. Neponechali vůbec nic náhodě. Skvělá práce. S čím mě ale šokovali nejvíc? Naprosto suverénně mi rozleštili lehké škrábnutí z parkoviště. Vůbec není poznat, že se o mě někdo opřel. Pánové fakt díky.",
    },
    {
      name: "Lukáš D.",
      source: "Google",
      text: "Naprosto perfektní, od komunikace až po finální výsledek, kluci jsou mistři v oboru!! Salon naprosto předčil všechna očekávání, auto se blýská, že se nemůžu vynadívat. Všem doporučuji a určitě se budu rád vracet.",
    },
  ],
};

export const whatsappLink = (text = "Dobrý den, chtěl bych si rezervovat termín v Car Spa.") =>
  `https://wa.me/${SITE.whatsappRaw}?text=${encodeURIComponent(text)}`;
